import React, { useState } from "react";
import { MdArrowDropDown } from 'react-icons/md';

const SponsorsMobileDropdown = ({ activeSection, setActiveSection, tierColors, sponsors, gradientString }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div 
      className="md:hidden relative px-4 py-8"
      style={{ background: gradientString }}
    >
      <button
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        className={`
          text-left transition-all duration-300 cursor-pointer
          font-bold text-5xl flex items-center
          ${tierColors[activeSection]}
        `}
      >
        {activeSection}
        <span className="ml-2">
          <MdArrowDropDown />
        </span>
      </button>

      {mobileMenuOpen && (
        <div className="fixed top-0 left-0 w-full h-screen bg-gray-400 bg-opacity-90 z-50 flex flex-col justify-center pl-4 font-">
          {/* Optional Close Button */}
          <button
            onClick={() => setMobileMenuOpen(false)}
            className="self-end text-white text-3xl font-bold mr-4 absolute top-32 right-4"
          >
            X
          </button>

          {Object.keys(sponsors).map((tier) => (
            <button
              key={tier}
              onClick={() => {
                setActiveSection(tier);
                setMobileMenuOpen(false);
              }}
              className={`
                transition-all duration-300 cursor-pointer text-left py-2
                ${activeSection === tier ? "text-5xl" : "text-3xl"}
                ${activeSection === tier ? tierColors[tier] : "text-white"}
              `}
            >
              {tier}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SponsorsMobileDropdown;
